import { removeUndefined } from '@utils/objects';
import { randomId } from '@utils/strings';

import { FieldDefaultProps, FieldId, FieldType, FieldTypeKind } from './types';

export const createFieldOfKind = <
  T extends FieldType['kind'],
  Y extends Extract<FieldType, { kind: T }>,
>(
  kind: T,
  opts?: Partial<FieldDefaultProps<T> & { id?: FieldId }>,
) => {
  return {
    kind,
    id: opts?.id ?? randomId(),
    ...fieldDefaultProps[kind],
    ...removeUndefined(opts ?? {}),
  } as Y;
};

type DefaultPropsMap<Kinds extends FieldTypeKind = FieldTypeKind> = {
  [K in Kinds]: FieldDefaultProps<K>;
};

export const fieldDefaultProps: DefaultPropsMap = {
  submit: {
    label: 'Submit',
  },

  'input-date': {
    isRequired: false,
    label: 'Date',
    description: '',
    placeholder: 'Choose date',
    condition: { op: 'AND', conditions: [] },
    defaultValue: '',
    dateRestrictionType: 'none',
    dateRangeStart: undefined,
    dateRangeEnd: undefined,
    value: '',
  },

  heading: {
    label: 'Heading',
    condition: { op: 'AND', conditions: [] },
  },

  subheading: {
    label: 'Subheading',
    condition: { op: 'AND', conditions: [] },
  },

  html: {
    content: '<p>Text</p>',
    condition: { op: 'AND', conditions: [] },
  },

  section: {
    columns: 1,
    label: 'Section',
    fields: [],
    condition: { op: 'AND', conditions: [] },
  },

  'input-text-small': {
    isRequired: false,
    label: 'Short text',
    description: '',
    placeholder: '',
    condition: { op: 'AND', conditions: [] },
    defaultValue: '',
    value: '',
  },

  'input-text-large': {
    isRequired: false,
    label: 'Long text',
    description: '',
    placeholder: '',
    condition: { op: 'AND', conditions: [] },
    defaultValue: '',
    value: '',
  },

  'input-kennitala': {
    isRequired: false,
    label: 'Kennitala',
    description: '',
    placeholder: '',
    condition: { op: 'AND', conditions: [] },
    defaultValue: '',
    value: '',
  },

  'input-number': {
    isRequired: false,
    label: 'Number',
    description: '',
    placeholder: '',
    condition: { op: 'AND', conditions: [] },
    defaultValue: null,
    isDecimal: false,
    restrictMin: false,
    min: null,
    restrictMax: false,
    max: null,
    allowNegative: false,
    value: null,
  },

  'input-file': {
    isRequired: false,
    label: 'File',
    description: '',
    allowMultiple: false,
    placeholder: 'Choose file',
    condition: { op: 'AND', conditions: [] },
    accept: '',
    restrictTypes: false,
    restrictFileSize: false,
    maxFileSizeMb: null,
    value: [],
  },

  'input-single-choice': {
    isRequired: false,
    label: 'Single choice',
    description: '',
    options: [],
    condition: { op: 'AND', conditions: [] },
    defaultValue: null,
    optionsFromListId: null,
    excludedOptions: [],
    hasCustomOption: false,
    customOptionLabel: '',
    value: null,
  },

  'input-multiple-choice': {
    isRequired: false,
    label: 'Multiple choice',
    description: '',
    options: [],
    condition: { op: 'AND', conditions: [] },
    defaultValue: [],
    optionsFromListId: null,
    excludedOptions: [],
    hasCustomOption: false,
    customOptionLabel: '',
    value: [],
  },

  'input-dropdown': {
    label: 'Dropdown',
    description: '',
    isRequired: false,
    options: [],
    placeholder: 'Select...',
    condition: { op: 'AND', conditions: [] },
    defaultValue: null,
    optionsFromListId: null,
    excludedOptions: [],
    hasCustomOption: false,
    customOptionLabel: '',
    value: null,
  },

  'input-phone': {
    label: 'Phone number',
    description: '',
    isRequired: false,
    condition: { op: 'AND', conditions: [] },
    defaultValue: '',
    value: '',
  },

  'input-email': {
    label: 'Email address',
    description: '',
    confirmLabel: 'Confirm email address',
    isRequired: false,
    hasConfirmation: false,
    condition: { op: 'AND', conditions: [] },
    defaultValue: '',
    placeholder: '',
    value: '',
  },

  image: {
    imageWidth: 100,
    condition: { op: 'AND', conditions: [] },
    url: '',
    imageId: '',
  },
  video: {
    condition: { op: 'AND', conditions: [] },
    url: '',
  },
  'content-file': {
    condition: { op: 'AND', conditions: [] },
    label: '',
    fileAlias: '',
    url: '',
    fileName: '',
  },
  separator: {
    condition: { op: 'AND', conditions: [] },
  },
};
